module.exports = __webpack_public_path__ + "img/font-size.ee629e9b.svg";